module.exports = __webpack_public_path__ + "static/media/image_1.5f0982c4.jpg";